import en from './translations/en/app.json';
import jp from './translations/jp/app.json';
import fr from './translations/fr/app.json';

const languages = ["en", "jp", "fr"];
const DEFAULT_LANGUAGE = "en";

let text = {};
let selected = localStorage.getItem('language');

text.en = en;
text.jp = jp;
text.fr = fr;

let setLanguage = language => {

	if (!languages.includes(language)) language = DEFAULT_LANGUAGE;
	localStorage.setItem('language', language)
	if (selected !== language)
		Object.keys(localStorage).forEach(key => { if (key.startsWith('library.') && !key.endsWith('.version')) localStorage.removeItem(key); });
	selected = language;
	document.documentElement.lang = language === 'jp' ? 'ja' : language;
}

let getLanguage = () => {

	return selected;
}

let read = id => {

	const find = dictionary => id.split('/').reduce((value, key) => value?.[key], dictionary);
	return find(text[selected]) ?? find(en) ?? id;
}


if (!languages.includes(selected))
	setLanguage(DEFAULT_LANGUAGE);

document.documentElement.lang = selected === 'jp' ? 'ja' : selected;

export { read, getLanguage, setLanguage };
